export default __webpack_public_path__ + "static/media/cbcSala2.1d3fdb92.jpg";